exports.cpf = require('./cpf');
exports.random = require('./random');
exports.cnpj = require('./cnpj');
exports.creditCard = require('./credit_card');